import React from 'react';
import ReactDOM from 'react-dom/client';

import Core from './components/Core';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css';
import './css/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(<Core />);